export type CrmKanbanView = 'board' | 'list';

const STORAGE_KEY = 'crm.kanban.view';

/// Lembrada por navegador; sem acesso ao armazenamento (privado, cota), fica o quadro.
export function readKanbanView(): CrmKanbanView {
    try {
        return localStorage.getItem(STORAGE_KEY) === 'list' ? 'list' : 'board';
    } catch {
        return 'board';
    }
}

export function saveKanbanView(view: CrmKanbanView): void {
    try {
        localStorage.setItem(STORAGE_KEY, view);
    } catch {
        // Sem armazenamento a escolha vale só até recarregar.
    }
}
